var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('MixLoginDialog',{attrs:{"show":_vm.show},on:{"update:show":function($event){_vm.show=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }